<template>
  <a-card>
    <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
      <a-form-item label="项目名称" name="projectName">
        <a-input v-model:value="searchForm.projectName" placeholder="请输入" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="onReset">重置</a-button>
      </a-form-item>
    </a-form>
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #picture="{ record }">
        <div style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
          <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.picture" :showList="true"
            disabled />
        </div>
      </template>
      <template #projectName="{ record }">
        <a @click="onDetail(record)">{{ record.projectName }}</a>
      </template>
      <template #projectPhase="{ text }">
        <dict-render :dict-obj="dictObjs['projectStage']" :text="text" v-if="text"></dict-render>
      </template>
      <template #isShow="{ record }">
        <switch-btn :value="record.isShow" key-field="isShow" :switch-url="editUrl" :checkedValue="'0'"
          :uncheckedValue="'1'" :params="{ id: record.key, companyCode: record.companyCode }" @ok="loadData" />
      </template>
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="onEdit(record)">编辑</a>
          <a @click="onDocking(record)">对接列表</a>
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DockingModal ref="dockingModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import DetailModal from './components/DetailModal';
import UserModal from './components/UserModal';
import { tableListMixin, dictMixin } from "@/mixins";
import { corpProjectInfo, technologyDemandInfo } from "@/api/achievementsService";
import { defaultDateCustomRender } from '@/utils/customRender';
import DockingModal from './components/DockingModal';

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "项目图片", dataIndex: "picture", key: "picture", slots: { customRender: "picture" } },
  { title: "项目名称", dataIndex: "projectName", key: "naprojectNameme", slots: { customRender: "projectName" } },
  { title: "项目总投资(万元)", dataIndex: "investment", key: "investment" },
  { title: "项目开始时间", dataIndex: "startTimeInterva", key: "startTimeInterva", customRender: defaultDateCustomRender },
  { title: "项目负责人", dataIndex: "projectLinkman", key: "projectLinkman" },
  { title: "联系电话", dataIndex: "phone", key: "phone" },
  // { title: "是否公开", dataIndex: "isShow", key: "isShow", slots: { customRender: "isShow" } },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin],
  components: {
    DetailModal, UserModal, DockingModal
  },
  data() {
    return {
      dictNames: "projectStage",
      columns,
      queryParam: {},
      listUrl: corpProjectInfo.pageList,
      listKeyField: "id",
      deleteUrl: corpProjectInfo.remove,
      editUrl: corpProjectInfo.saveOrUpdate,
    }
  },
  methods: {
    onAdd() {
      this.onShowModal('userModal');
    },
    onEdit(record) {
      this.getAction({
        url: corpProjectInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onDetail(record) {
      this.getAction({
        url: corpProjectInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('detailModal', res);
      })
    },
    onDocking(record) {
      this.getAction({
        url: technologyDemandInfo.pageList,
        params: { functionId: record.id }
      }).then(r => {
        let obj = {
          technologyDemand: r.records || []
        }
        this.onShowModal('dockingModal', obj);
      })
    },
  }
}
</script>

<style scoped></style>
